import FieldPopover from "../../generic/popover/popover"

import FieldSelectTask_Popover from "./components/popover/popover"
import FieldSelectTask_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldConfig from "../../proto/field-config"
import FieldSelectTask_FormValueEmpty from "./components/form/value-empty";


export default class FieldSelectTask extends FieldPopover {


    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel                      = "Select Task"

        this.components.PopoverMenu         = FieldSelectTask_Popover

        this.components.FormValueEmpty      = FieldSelectTask_FormValueEmpty
        this.components.FormValueNotEmpty   = FieldSelectTask_FormValueNotEmpty


    }

}
